export interface ReleaseInvoicesDialogDataInterface {
  invoicesToRelease: number;
}

export class ReleaseInvoicesDialogData implements ReleaseInvoicesDialogDataInterface {
  constructor(public invoicesToRelease: number) {}
}
